import {useContext, useState, useEffect } from "react";
import {ModalContext} from "../../../utils/modal/ModalProvider";
import {containsXss} from "../../../utils/security/XssFilter";
import {DialogEnum, showDialog} from "../../../utils/dialog/Dialog";
import {IAM_PATH, IAM_SERVER_SERVICE_PRODUCT} from "../../../utils/Config";
import axios from "../../../utils/api/axios";
import styles from '../../../utils/modal/DetailModal.module.css';
// import { ConstructionTwoTone } from "@mui/icons-material";


/**
 * 그룹 등록 모달 Container
 * @param update
 * @returns {JSX.Element}
 * @constructor
 */
export const SoftwareRegisterModal = ({update, selectedServiceId, groupData, selectedGroupId}) => {
    const {closeModal} = useContext(ModalContext);
    const [isNull, setIsNull] = useState(false); //빈 값 확인
    // const [isDuplicateChecked, setIsDuplicateChecked] = useState(false); // 중복 확인 완료 여부

    const [formData, setFormData] = useState({
        product: ''
    });

    useEffect(() => {
        
    }, []);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    }

    // 서비스스 등록 요청 API
    const handleRegister = () => {
        for (let key in formData) {
            if (key !== 'parentGroupId' && formData[key] === '' && key !== 'groupDescription') {
                setIsNull(true);
                return;
            } else if (containsXss(formData[key])) {
                setFormData((prevState) => ({
                    ...prevState,
                    [key]: ''
                }));
                setIsNull(true);
                showDialog(DialogEnum.DEFAULT, "경고", "올바른 값을 입력해 주세요.");
                return;
            }
        }      
        setIsNull(false);

        let newFormData = { ...formData };
        const params = {
            product: newFormData.product,
        };
        
        const url = IAM_PATH + IAM_SERVER_SERVICE_PRODUCT + "/create";

        axios.post(url, params)
            .then((res) => {
                if (res.data.code == 200) {
                    showDialog(DialogEnum.SUCCESS, "성공", "등록 성공", closeModal);
                    update();
                } else {
                    showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                }
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
                console.error(e)
            });
    }


    return (
        <div>
            <ul className={styles.layer__listWrap}>
                <li className={styles.layer__list}>
                    <p className={styles.layer__listTit}>제품명</p>
                    <input className={styles.layer__listInput}
                           type={"text"}
                           name={"product"}
                           value={formData.product}
                           onChange={handleChange}
                           maxLength={30}
                           />
                </li>
            </ul>

            {isNull ? <div className={`${styles.layer__text} ${styles.warning}`}>빈 칸을 확인해 주세요.</div> : null}
            <button className={styles.layer__saveBtn} onClick={handleRegister}>등록</button>
        </div>
    )
}